import {
  HelpCenterFAQEvent,
  HelpCenterSelectedCategoryEvent,
  HelpCenterSelectedQuestionEvent
} from '../types';

export const getFaqClickEvent = (question: string): HelpCenterFAQEvent => {
  return {
    event: 'help_center_faq',
    faq_question: question
  };
};

export const getSelectedCategoryEvent = (category: string): HelpCenterSelectedCategoryEvent => {
  return {
    event: 'help_center_category',
    category
  };
};

export const getSelectedQuestionEvent = (
  category: string,
  question: string
): HelpCenterSelectedQuestionEvent => {
  return {
    event: 'help_center_question',
    category,
    question
  };
};
